<div [class]="{ 'card': !entityId() }">
  <app-grid-server-side
    [storageKey]="storageKey()!"
    [defaultExcelExportParams]="excelExportParams"
    [defaultCsvExportParams]="csvExportParams"
    [excelStyles]="excelStyles"
    [colDefs]="$any(colDefs())"
    [pinFirstColumnName]="pinFirstColumnName"
    [totalRows]="totalRecords()"
    [pageTitle]="pageTitle"
    [suppressRowClickSelection]="true"
    [serverSideDatasource]="dataSource()"
    [getRowId]="getRowId"
    [paginationPageSize]="defaultPageSize"
    [cacheBlockSize]="cacheBlockSize"
    (search)="onSearch($event)"
    (gridReady)="onGridReady($event)"
    (select)="selectDocuments($event)"
  >
    <div class="grid-controls-end d-flex justify-content-end gap-12">
      @if (selectedDocuments.length) {
        <div ngbDropdown [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']" class="dropdown">
          <app-button
            ngbDropdownToggle
            class="hide-button-text-thin-page"
            id="bulk-actions-dd"
            text="Actions"
            iconClass="icon ic-select-20"
            [iconLast]="true"
            [isDisabled]="modalOpened()"
          />

          <div
            ngbDropdownMenu
            aria-labelledby="bulk-actions-dd"
            class="common-dropdown-menu dropdown-menu dropdown-menu-right"
          >
            @for (item of getMainMenuAction(); track $index) {
              <button ngbDropdownItem (click)="item.action()">
                <span>{{ item.name }}</span>
              </button>
            }
          </div>
        </div>
      } @else {
        <app-button
          id="export-company-list-dd"
          class="hide-button-text-thin-page"
          title="Export Documents List"
          iconClass="icon ic-download-20"
          btnColor="white"
          [isDisabled]="modalOpened()"
          (clickBtn)="exportDocumentsList(false, ExportTypeEnum.EXCEL)"
        />
      }
    </div>
  </app-grid-server-side>
</div>

<app-notes
  [entity]="entityForNotes"
  [entityType]="EntityType.Company"
  [opened]="notesVisible"
  (close)="notesVisible = false"
/>
